// --- Load More + Filter Logic ---

export function initGrid() {
  document.addEventListener("DOMContentLoaded", () => {
    const grid = document.querySelector("#projekt-grid");
    const loadMoreBtn = document.getElementById("load-more");
    const filterBtns = document.querySelectorAll(
      ".projekt-taxonomy-filters [data-term]",
    );

    if (!grid) return;

    const GRID_SLOT_CLASSES = [
      "grid-big-top-left",
      "grid-quad-top-right-1",
      "grid-quad-top-right-2",
      "grid-quad-top-right-3",
      "grid-quad-top-right-4",
      "grid-quad-bottom-left-1",
      "grid-quad-bottom-left-2",
      "grid-quad-bottom-left-3",
      "grid-quad-bottom-left-4",
      "grid-wide-bottom-right",
      "grid-two-bottom-right-1",
      "grid-two-bottom-right-2",
    ];

    function hideWithAnim(el) {
      if (getComputedStyle(el).display === "none") return;
      if (el.dataset.hiding === "true") return;
      el.dataset.hiding = "true";

      el.classList.add("is-hiding");

      const onEnd = (ev) => {
        if (ev.propertyName !== "opacity") return;
        el.style.display = "none";
        el.classList.remove("is-hiding");
        delete el.dataset.hiding;
        el.removeEventListener("transitionend", onEnd);
      };

      el.addEventListener("transitionend", onEnd);
    }

    function showWithAnim(el) {
      if (getComputedStyle(el).display !== "none") return;
      el.classList.add("pre-animate");
      el.style.display = "";
      void el.offsetWidth;
    }

    const normalizeGridLayout = (term = "alle") => {
      const items = Array.from(grid.querySelectorAll(".projekt-grid__item"));
      const useUniform =
        grid.classList.contains("uniform-grid") || term !== "alle";

      if (useUniform) {
        items.forEach((item) => item.classList.remove(...GRID_SLOT_CLASSES));
      }
    };

    const animateVisibleItems = () => {
      const items = Array.from(grid.querySelectorAll(".projekt-grid__item"));
      items.forEach((item) => {
        item.classList.add("pre-animate");
        void item.offsetWidth;
        item.classList.remove("pre-animate");
      });
    };

    const applyFilter = (term = "alle") => {
      const items = Array.from(grid.querySelectorAll(".projekt-grid__item"));
      normalizeGridLayout(term);

      const itemsToShow = [];
      const itemsToHide = [];

      items.forEach((item) => {
        const itemTerms = (item.dataset.terms || "")
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);
        const shouldShow = term === "alle" || itemTerms.includes(term);
        if (shouldShow) itemsToShow.push(item);
        else itemsToHide.push(item);
      });

      itemsToHide.forEach((item) => item.classList.add("is-hiding"));

      setTimeout(() => {
        itemsToHide.forEach((item) => {
          item.classList.remove("is-hiding");
          item.style.display = "none";
        });

        itemsToShow.forEach((item) => {
          item.style.display = "";
          item.classList.add("pre-animate");
          void item.offsetWidth;
          item.classList.remove("pre-animate");
        });
      }, 350);

      return itemsToShow.length;
    };

    let nextPageUrl = loadMoreBtn?.getAttribute("data-next-url") || null;
    let originalLoadMoreText = loadMoreBtn
      ? (loadMoreBtn.textContent || "Mehr laden").trim()
      : "Mehr laden";
    let currentPage = 1;
    let activeTerm = "alle";
    let hasMoreProjects = Boolean(nextPageUrl);
    const endpoint = window.gpProjectGrid?.endpoint || null;
    const sourcePage = grid.dataset.sourcePage || "arbeiten";

    function updateLoadMoreUI(isLoading = false) {
      if (!loadMoreBtn) return;
      if (isLoading) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "Lade...";
        return;
      }
      if (hasMoreProjects) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = originalLoadMoreText;
      } else {
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "Keine weiteren Projekte";
      }
    }

    async function fetchProjectPage(term = "alle", page = 1) {
      if (!endpoint) return fetchNextPage();

      const url = new URL(endpoint);
      url.searchParams.set("term", term);
      url.searchParams.set("page", page);
      url.searchParams.set("source", sourcePage);

      const res = await fetch(url.toString(), { credentials: "same-origin" });
      if (!res.ok) throw new Error("Projekt-Grid konnte nicht geladen werden.");
      return res.json();
    }

    function renderProjectPage(data, mode = "replace") {
      if (mode === "replace") {
        grid.innerHTML = data.html || "";
      } else {
        const template = document.createElement("template");
        template.innerHTML = data.html || "";
        Array.from(template.content.children).forEach((el) => {
          el.classList.add("loaded");
          grid.appendChild(el);
        });
      }

      currentPage = data.page || currentPage;
      hasMoreProjects = Boolean(data.hasMore);
      nextPageUrl = hasMoreProjects ? "rest" : null;
      normalizeGridLayout(activeTerm);
      animateVisibleItems();
    }

    async function fetchNextPage() {
      if (!nextPageUrl) return { appended: 0 };

      const res = await fetch(nextPageUrl, { credentials: "same-origin" });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const nextGrid = doc.querySelector("#projekt-grid");
      const items = nextGrid
        ? Array.from(nextGrid.querySelectorAll(".projekt-grid__item"))
        : [];

      items.forEach((el) => {
        const clone = el.cloneNode(true);
        clone.classList.add("loaded");
        grid.appendChild(clone);
      });

      const nextBtn = doc.querySelector("#load-more[data-next-url]");
      nextPageUrl = nextBtn ? nextBtn.getAttribute("data-next-url") : null;

      return { appended: items.length };
    }

    let loading = false;

    filterBtns.forEach((btn) => {
      btn.addEventListener("click", async () => {
        if (loading) return;
        loading = true;

        filterBtns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        const term = btn.dataset.term;
        activeTerm = term || "alle";
        currentPage = 1;

        grid.classList.toggle("uniform-grid", activeTerm !== "alle");

        updateLoadMoreUI(true);

        try {
          if (endpoint) {
            const data = await fetchProjectPage(activeTerm, currentPage);
            renderProjectPage(data, "replace");
          } else {
            applyFilter(activeTerm);
          }
        } finally {
          updateLoadMoreUI(false);
          loading = false;
        }
      });
    });

    loadMoreBtn?.addEventListener("click", async () => {
      if (loading || !hasMoreProjects) return;
      loading = true;
      updateLoadMoreUI(true);

      const activeBtn = document.querySelector(
        ".projekt-taxonomy-filters [data-term].active",
      );
      activeTerm = activeBtn ? activeBtn.dataset.term : "alle";

      try {
        if (endpoint) {
          const data = await fetchProjectPage(activeTerm, currentPage + 1);
          renderProjectPage(data, "append");
        } else {
          await fetchNextPage();
          applyFilter(activeTerm);
          hasMoreProjects = Boolean(nextPageUrl);
        }
      } finally {
        updateLoadMoreUI(false);
        loading = false;
      }
    });

    if (filterBtns.length) {
      filterBtns[0].classList.add("active");
    }
    applyFilter("alle");
    updateLoadMoreUI(false);
  });
}
